import { Link } from "react-router-dom";
import { allArticles } from "@/mocks/articles";

export default function ArticlesSection() {
  const displayArticles = allArticles.slice(0, 12);

  return (
    <section className="w-full bg-background-50 py-16 md:py-20">
      <div className="w-full px-6 md:px-10">
        {/* Section Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-12">
          <div>
            <span className="inline-block px-3 py-1 text-xs font-medium text-primary-700 bg-primary-100 rounded-full mb-3">
              Latest Resources
            </span>
            <h2 className="text-3xl md:text-4xl font-heading text-foreground-900">
              Guides &amp; Articles
            </h2>
          </div>
          <p className="text-sm text-foreground-600 max-w-md">
            In-depth articles covering VigorBuy Spreadsheet usage, safety practices, shipping
            guides, and product comparisons — each with internal links back to the home page.
          </p>
        </div>

        {/* Article Cards - 4 rows x 3 columns on desktop */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {displayArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group block bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-200"
            >
              {/* Image */}
              <div className="w-full h-44 md:h-48 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              {/* Content */}
              <div className="p-4 md:p-5">
                <span className="inline-block px-2.5 py-1 text-xs font-medium text-primary-700 bg-primary-100 rounded-full mb-3">
                  {article.tag}
                </span>
                <h3 className="text-base md:text-lg font-heading text-foreground-900 mb-2 leading-snug group-hover:text-primary-600 transition-colors duration-200 line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-1.5 mt-3 text-sm font-medium text-primary-600">
                  Read Article
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-sm"></i>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}